import History from '~/utils/history';
import { urlsMap } from '~/utils/menu';
import { openBundleByUrl, openCategoryByName } from '~/utils/category';
import ViewCardContainer from '~/containers/ViewCardContainer/ViewCardContainer';
import CategoryContainer from '~/containers/CategoryContainer/CategoryContainer';
import { useParams } from 'react-router-dom';
import { routingStateSelector } from '~/routing/routingState';
import equal from 'fast-deep-equal/react';
import { isBundleDisabledForUser, isCategoryDisabledForUser, isCurrentCategory } from '~/routing/helpers';
import { useAppSelector } from '~/Store';
import { BUNDLE_TYPES } from '~/types/bundle';
import { isFullLimitedInteraction } from '~/utils/bundles';

export default function BundlePageRouter() {
    const { id, categoryName } = useParams();
    const { currentPage, bundles, categories } = useAppSelector(routingStateSelector, equal);

    const isBundle = /^[0-9]+$/.test(id);
    if (isBundle) {
        const currentBundle = bundles[id];
        if (!currentBundle) {
            History.navigate(urlsMap.home, { replace: true });
            return;
        }

        const category = categories[currentPage?.name || categoryName] as ICategory;

        if (isFullLimitedInteraction(currentBundle)) {
            const firstCategory = currentBundle.categories?.at(0);
            if (firstCategory) {
                openCategoryByName(firstCategory);
            } else {
                History.navigate(urlsMap.home, { replace: true });
            }
            return;
        }

        if (isBundleDisabledForUser(currentBundle, category)) {
            History.navigate(urlsMap.home, { replace: true });
            return;
        }

        if (!History.hasHistory()) {
            if (currentBundle && currentBundle.type === BUNDLE_TYPES.mystery) {
                openCategoryByName(category.name);
                return null;
            }
            if (currentBundle && !isCurrentCategory(categoryName, categories[currentBundle.categories.at(0)])) {
                openBundleByUrl(currentBundle.categories.at(0), currentBundle?.id, undefined, true);
                return null;
            }
        }

        return <ViewCardContainer params={{ categoryName, id: +id }} />;
    }

    if (isCategoryDisabledForUser(categoryName, id, categories)) {
        History.navigate(urlsMap.home, { replace: true });
        return;
    }

    return <CategoryContainer params={{ categoryName, id }} />;
}
